import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Button from "../../../components/Button/Button";
import Container from "../../../components/Container/Container";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import { useUserStore } from "../../../contexts/userStore";
import UnitService from "../../../services/UnitService";
import "./FormBatchUnits.css";
import { DynamicIcon } from "../../../components/DynamicIcon/DynamicIcon";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { capitalize, pluralizePortuguese } from "../../../utils/string";
import { NotificationManager } from "react-notifications";
import { DynamicTagFields } from "../../../components/DynamicTagFields/DynamicTagFields";
import { useAuth } from "../../../contexts/auth";
import { UnitSelector } from "../../../components/UnitSelector/UnitSelector";

function FormBatchUnits(props) {
  const { user } = useAuth();
  const [previewUnitsArray, setPreviewUnitsArray] = useState([]);
  const [initialUnit, setInitialUnit] = useState("");
  const [customInput2, setCustomInput2] = useState("");
  const [customInput3, setCustomInput3] = useState("");
  const [parkingLotQuantity, setParkingLotQuantity] = useState();
  const [parkingLotBusy, setParkingLotBusy] = useState();
  const [numberOfDivisions, setNumberOfDivisions] = useState();
  const [quantityPerDivision, setQuantityPerDivision] = useState();
  const [incrementPerDivision, setIncrementPerDivision] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const { selectedCondominio } = useUserStore();
  const navigate = useNavigate();
  const [showPreview, setShowPreview] = useState(false);
  const [metadata, setMetadata] = useState([]);
  const [parentId, setParentId] = useState(selectedCondominio);

  const tagTitle = (props.tag?.name || 'unidade').toLowerCase();
  const tagTitleCap = capitalize(tagTitle);
  const tagTitlePluralized = pluralizePortuguese(tagTitle);
  const tagTitleCapPluralized = pluralizePortuguese(tagTitleCap);

  const buildPayload = (unitsArrayWithDivision) => {
    return {
      initialUnit: parseInt(initialUnit),
      numberOfDivisions: parseInt(numberOfDivisions),
      quantityPerDivision: parseInt(quantityPerDivision),
      incrementPerDivision: parseInt(incrementPerDivision),
      parentId: `${parentId}`,
      organizationId: `${user.userData.selectedOrganizationId}`,
      isDeviceUnit: true,
      tags: [props.tag.externalId],
      metadata: [
        {
          name: 'parkingLotQuantity',
          label: 'parkingLotQuantity',
          value: parkingLotQuantity,
        },
        {
          name: 'parkingLotBusy',
          label: 'parkingLotBusy',
          value: parkingLotBusy,
        },
        ...metadata.filter(item => !['parkingLotQuantity', 'parkingLotBusy'].includes(item.name))
      ],
    };
  };

  const calculateUnitsValues = () => {
    const outerArray = [];
    let divisions = parseInt(numberOfDivisions);
    let quantity = parseInt(quantityPerDivision);
    let increment = parseInt(incrementPerDivision);
    let initial = parseInt(initialUnit);
    let value = 0;

    for (let i = 0; i < divisions; i++) {
      outerArray.push([]);
      for (let j = 0; j < quantity; j++) {
        outerArray[i].push({
          name_local: value + initial,
          id_client: user.userData.selectedOrganizationId,
          parent_unit_id: `${parentId}`,
          is_device_unit: true,
          uuid: uuidv4(),
        });
        value++;
      }
      value = increment * (i + 1);
    }

    setPreviewUnitsArray(outerArray);
    return outerArray;
  };

  useEffect(() => {
    calculateUnitsValues();
  }, [
    numberOfDivisions,
    quantityPerDivision,
    incrementPerDivision,
    initialUnit
  ]);

  async function handleSubmit(event) {
    event.preventDefault();
    const unitsArrayWithDivision = calculateUnitsValues();
    const payload = buildPayload(unitsArrayWithDivision);
    setShowLoader(true);
    await UnitService.createBatchUnit(payload);
    if (props.tag) {
      navigate(`/consulta-units/${props.tag?.externalId}`);
    }
    setShowLoader(false);
  }

  return (
    <React.Fragment>
      <FormTitle
        type={"cadastro"}
        icon={props.tag?.icon ? <DynamicIcon iconName={props.tag.icon} size={20} color={'white'} /> : <MdOutlineMapsHomeWork size={20} />}
        tituloCadastro={`Cadastro em Lote de ${tagTitleCapPluralized}`}
      />
      {showLoader ? (
        <Loader />
      ) : (
        <Form
          handleSubmit={handleSubmit}
          type={"cadastro"}
          navigateCancelUrl="../consulta-units"
        >
          <div className="container-form-batch-units">
            <div className="container-form-inputs">
              <div className="grid-2" style={{ width: "100%" }}>
                {props.unitsConfigs?.enableInput2 && (
                  <Input
                    name="customInput2"
                    id="customInput2"
                    labelText={props.unitsConfigs?.placeholderInput2}
                    value={customInput2}
                    onChange={({ target }) => {
                      setCustomInput2(target.value);
                    }}
                    disabled={props.type === "consulta"}
                    required={true}
                  />
                )}
                <Input
                  name="initialUnit"
                  id="initialUnit"
                  type="number"
                  labelText={`${tagTitleCap} Inicial`}
                  value={initialUnit}
                  onChange={({ target }) => {
                    setInitialUnit(target.value);
                  }}
                  required={true}
                  min={0}
                  max={10000}
                />
                <UnitSelector
                  scopedUnitId={selectedCondominio}
                  parentId={parentId}
                  setParentId={setParentId}
                />
                <Input
                  name="quantityPerDivision"
                  id="quantityPerDivision"
                  type="number"
                  labelText="Quantidade por divisão"
                  value={quantityPerDivision}
                  onChange={({ target }) => {
                    setQuantityPerDivision(target.value);
                  }}
                  required={true}
                  min={0}
                  max={20}
                />
                {props.unitsConfigs?.enableInput3 && (
                  <Input
                    name="customInput3"
                    id="customInput3"
                    labelText={props.unitsConfigs?.placeholderInput3}
                    value={customInput3}
                    onChange={({ target }) => {
                      setCustomInput3(target.value);
                    }}
                    disabled={props.type === "consulta"}
                    required={true}
                  />
                )}
                <Input
                  name="numberOfDivisions"
                  id="numberOfDivisions"
                  type="number"
                  labelText="Número de divisões"
                  value={numberOfDivisions}
                  onChange={({ target }) => {
                    setNumberOfDivisions(target.value)
                  }}
                  required={true}
                  min={0}
                  max={40}
                />
                <Input
                  name="incrementPerDivision"
                  id="incrementPerDivision"
                  type="number"
                  labelText="Incremento por divisão"
                  value={incrementPerDivision}
                  onChange={({ target }) => {
                    setIncrementPerDivision(target.value);
                  }}
                  required={true}
                  min={0}
                  max={10000}
                />
                {props.tag?.parkingLimit && (
                  <>
                    <Input
                      name="parkingLotBusy"
                      id="parkingLotBusy"
                      type="number"
                      tooltipText={`Vagas ocupadas para cada ${tagTitle}`}
                      tooltipVisible={true}
                      labelText="Vagas Ocupadas"
                      value={parkingLotBusy}
                      onChange={({ target }) => {
                        setParkingLotBusy(target.value);
                      }}
                      required={true}
                    />
                    <Input
                      name="parkingLotQuantity"
                      id="parkingLotQuantity"
                      type="number"
                      tooltipText={`Quantidade de vagas para cada ${tagTitle}`}
                      tooltipVisible={true}
                      labelText="Número de vagas"
                      value={parkingLotQuantity}
                      onChange={({ target }) => {
                        setParkingLotQuantity(target.value);
                      }}
                      required={true}
                    />
                  </>
                )}
              </div>
              <DynamicTagFields
                tag={props.tag}
                metadata={metadata}
                setMetadata={setMetadata}
              />
              <div className="button-container" style={{ justifyContent: 'left' }}>
                <Button
                  onClick={() => {
                    if (!showPreview && previewUnitsArray.length === 0) {
                      NotificationManager.warning("Preencha todos os campos", "Atenção");
                      return;
                    }
                    setShowPreview(prev => !prev);
                  }}
                  className={"button-white preview-batch-units-button"}
                  label={showPreview ? "Esconder Resultados" : "Visualizar Resultados"}
                />
              </div>
            </div>
            {showPreview && previewUnitsArray.length > 0 && (
              <div className="preview-batch-units">
                <h3 className="bordered preview-batch-units-title">
                  Pré-visualização dos Resultados
                </h3>

                <div className="preview-batch-units-container">
                  {previewUnitsArray?.map((divisions, indexDivision) => (
                    <div
                      className="preview-batch-units-division"
                      key={indexDivision}
                    >
                      <p className="preview-batch-units-division-title">
                        Divisão {indexDivision + 1}
                      </p>
                      <div className="preview-batch-units-container-row">
                        {divisions?.map((units, indexUnits) => (
                          <p
                            className="preview-batch-units-row"
                            key={indexUnits}
                          >
                            {units?.name_local}
                          </p>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </Form>
      )}
    </React.Fragment>
  );
}

export default FormBatchUnits;
